import '../css/index.scss';
import APlayer from './player';
console.log('\n'.concat(' %c APlayer v', APLAYER_VERSION, ' ').concat(GIT_HASH, ' %c http://aplayer.js.org ', '\n'), 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
export default APlayer;